"use client";

import Link from "next/link";
import Image from "next/image";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
import { Menu, Flame } from "lucide-react";
import { useState } from "react";

const menuItems = [
  { href: "/", label: "Home" },
  { href: "/chatgpt-prompts", label: "ChatGPT Prompt Library" },
  { href: "/ai-tools", label: "AI Tools Directory" },
  { href: "/master-chatgpt-prompting-techniques-guide", label: "ChatGPT Prompt Guide", icon: <Flame className="h-4 w-4 text-[#B8EF52]" /> },
  { href: "/blog", label: "Blog" },
];

export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="w-full bg-zinc-900">
      <div className="max-w-[1400px] mx-auto flex h-16 items-center justify-between px-4 lg:px-0">
        <Link href="/" className="flex items-center text-white">
          <Image
            src="/images/gptbot-ai-logo.png"
            alt="GPTBot Logo"
            width={111}
            height={26}
            priority
            className="w-[90px] md:w-[111px]"
          />
        </Link>

        {/* Mobile Menu Button */}
        <button
          className="lg:hidden text-white p-2"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <Menu className="h-6 w-6" />
        </button>

        {/* Desktop Navigation */}
        <div className="hidden lg:block">
          <NavigationMenu>
            <NavigationMenuList className="gap-3">
              {menuItems.map((item) => (
                <NavigationMenuItem key={item.href}>
                  <Link href={item.href} legacyBehavior passHref>
                    <NavigationMenuLink 
                      className={cn(
                        "px-4 py-2 text-[13px] text-white hover:text-white hover:bg-white/10 transition-colors rounded-md font-normal flex items-center gap-2"
                      )}
                    >
                      {item.label}
                      {item.icon && item.icon}
                    </NavigationMenuLink>
                  </Link>
                </NavigationMenuItem>
              ))}
            </NavigationMenuList>
          </NavigationMenu>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="fixed inset-0 top-16 bg-zinc-900 z-50 lg:hidden border-t border-zinc-800 overflow-y-auto">
            <nav className="flex flex-col h-full">
              {menuItems.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  className="text-lg text-white hover:text-white hover:bg-white/10 transition-colors font-medium py-5 px-6 flex items-center gap-3 border-b border-zinc-800"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                  {item.icon && item.icon}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}